import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { ThreeDots } from "react-loader-spinner";

import cx from "classnames";
import { Warning } from "@material-ui/icons";
import Muted from "../Typography/Muted";
import Button from "../CustomButtons/Button";
import useThemeColors from "../../hooks/useThemeColors";
import ModalHeader from "../ModalHeader";

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle";

const styles = (theme) => ({
  ...modalStyle(theme),
  fontCenter: {
    textAlign: "center !important",
  },
  warningIcon: {
    color: "#ff9800",
    fontSize: "30px",
    marginRight: "12px",
  },
  contentContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  confirmButton: {
    minWidth: "80px",
    width: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 16px",
  },
  modalRootHigher: {
    zIndex: "1400 !important",
  },
});

const DeleteAdjustmentDialog = ({
  open,
  setOpen,
  onConfirm,
  isDeleting = false,
}) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const { t } = useTranslation();
  const { clientColor } = useThemeColors();

  return (
    <Dialog
      classes={{
        root: cx(classes.modalRoot, classes.modalRootHigher),
        paper: classes.modal,
      }}
      open={open}
      keepMounted
      onClose={() => !isDeleting && setOpen(false)}
      aria-labelledby="delete-adjustment-modal-title"
      aria-describedby="delete-adjustment-modal-description"
      fullWidth
      maxWidth={"xs"}
    >
      <ModalHeader
        id="delete-adjustment-modal-title"
        title={t("adjustments.delete_adjustment_title")}
        pills={[
          {
            key: "irreversible",
            label: t("common.irreversible"),
            tone: "error",
            dot: true,
          },
        ]}
        onClose={() => !isDeleting && setOpen(false)}
        closeDisabled={isDeleting}
        closeLabel={t("common.close")}
      />
      <DialogContent
        id="delete-adjustment-modal-description"
        className={classes.modalBody}
      >
        <div className={classes.contentContainer}>
          <Warning className={classes.warningIcon} />
          <Muted>{t("adjustments.delete_adjustment_body")}</Muted>
        </div>
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button
          onClick={() => !isDeleting && setOpen(false)}
          color="transparent"
          simple
          disabled={isDeleting}
        >
          {t("common.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          color="danger"
          simple
          disabled={isDeleting}
          className={classes.confirmButton}
        >
          {isDeleting ? (
            <ThreeDots
              height="18px"
              width="18px"
              color={clientColor}
              ariaLabel="loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          ) : (
            t("common.delete")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteAdjustmentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool,
};

export default DeleteAdjustmentDialog;
